<div *ngIf="!_disabled" [ngClass]="{ 'ng-invalid ng-dirty': isCurrentlyInvalid }">
	<label>
		{{ 'form.field.currency' | translate }}
		<span *ngIf="required" class="text-danger">*</span>
	</label>
	<input pInputText [value]="_value || ''" [placeholder]="'shared.currencySelect.placeholder' | translate"
		(input)="onCurrencyInputChange($event)" (blur)="propagateTouched()" [class.is-invalid]="isCurrentlyInvalid"
		[disabled]="_disabled" maxlength="3" class="w-100" />
	<div *ngIf="isCurrentlyInvalid" class="invalid-feedback text-danger d-block">
		{{ currentErrorMessage }}
	</div>
</div>